/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { forwardRef, useEffect, useState } from 'react'
import Select, { AriaOnFocus, MenuPlacement, MenuPosition, components } from 'react-select'

import { SELECT_MESSAGE } from '../constants/rhybus-config'
import InputLabel from './input-label'
import { Dropdown, optionsTypes } from './select-options-data'

interface Props {
  'aria-label'?: string
  badge?: any
  badgecount?: any
  className: string
  disabled?: boolean
  error?: boolean
  extras?: any
  extrasClassName?: any
  formClassName: string
  icon?: any
  id: string
  info?: any
  infoClassName?: string
  infoIcon?: any
  inline?: boolean
  inputProps?: any
  isInfo?: boolean
  isMandatory?: boolean
  isMulti?: boolean
  label?: string
  menuPlacement?: string
  menuPortalTarget?: any
  menuPosition?: string
  minMenuHeight?: number
  name: string
  onChange?: any
  options?: any[]
  placeholder?: any
  props?: any
  readonly?: boolean
  style?: any
  type?: string
  value?: boolean | number | string
}

interface option {
  label: string
  value: null | number | string
}

const CustomSelect = forwardRef((inputProps: Props, ref: any) => {
  const [ariaFocusMessage, setAriaFocusMessage] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isMenuOpen1, setIsMenuOpen1] = useState(false)
  const [valueLabel, setValueLabel] = useState('Select')
  const onFocus: AriaOnFocus<optionsTypes> = ({ focused, isDisabled }) => {
    const msg = `You are currently focused on option ${focused?.label}${isDisabled ? ', disabled' : ''
      }`
    setAriaFocusMessage(msg)
    return msg
  }
  const onkeyopenMenu = (event: { key: any }) => {
    if (event.key === 'Enter') {
      setIsMenuOpen1(!isMenuOpen1)
      setIsMenuOpen(!isMenuOpen)
    }
  }
  // const onMenuOpen = () => setIsMenuOpen(true)
  // const onMenuClose = () => setIsMenuOpen(false)
  const onMenuOpen = () => {
    setIsMenuOpen(true)
    setIsMenuOpen1(true)
  }
  const onMenuClose = () => {
    setIsMenuOpen(false)
    setIsMenuOpen1(false)
  }

  // When the value is updated, this use effect finds the appropriate label in order to update the value of the Select dropdown component
  useEffect(() => {
    inputProps?.options?.forEach((option: any) => {
      if (option.value === inputProps?.value) {
        setValueLabel(option.label ?? '')
      }
    })
  }, [inputProps?.options, inputProps?.value])

  return (
    <div className={inputProps?.formClassName}>
      {inputProps?.label && (
        <InputLabel
          className={inputProps?.inputProps?.className}
          extras={inputProps?.extras}
          extrasClassName={inputProps.extrasClassName}
          infoLabel={inputProps?.info}
          isinfoClassName={inputProps?.infoClassName}
          isinfoIcon={inputProps?.infoIcon}
          isinfoLabel={inputProps?.isInfo}
          label={inputProps?.label}
          labelProps={{ htmlFor: inputProps?.inputProps?.id }}
          mandatory={inputProps?.isMandatory}
        />
      )}
      <Select
        aria-label={inputProps['aria-label'] || inputProps?.label}
        aria-readonly={inputProps?.readonly}
        aria-required={inputProps?.isMandatory}
        ariaLiveMessages={{
          onFocus,
        }}
        className={inputProps?.className}
        classNamePrefix='react-select'
        closeMenuOnSelect={!inputProps?.isMulti}
        components={inputProps?.isMulti && {Option: Option, Placeholder: Placeholder}}
        defaultValue={inputProps?.isMulti ? inputProps?.value : null}
        hideSelectedOptions={false}
        id={inputProps?.id}
        inputId='aria-example-input'
        isDisabled={inputProps?.disabled}
        isMulti={inputProps?.isMulti}
        menuIsOpen={isMenuOpen1 || isMenuOpen}
        menuPlacement={inputProps?.menuPlacement as MenuPlacement}
        menuPortalTarget={inputProps?.menuPortalTarget}
        menuPosition={inputProps?.menuPosition as MenuPosition}
        minMenuHeight={inputProps?.minMenuHeight}
        name='aria-live-color'
        onChange={inputProps?.onChange}
        onKeyDown={onkeyopenMenu}
        onMenuClose={onMenuClose}
        onMenuOpen={onMenuOpen}
        options={inputProps?.options}
        ref={ref}
        styles={inputProps?.isMulti ? {
          clearIndicator: (base) => {
            return { ...base, cursor: 'pointer', zIndex: 2 }
          },
          dropdownIndicator: (base) => {
            return { ...base, cursor: 'pointer', zIndex: 2 }
          },
          menuPortal: (base) => {
            return { ...base, zIndex: 3 }
          },
          multiValue: (base) => {
            return { ...base, zIndex: 3 }
          }
        } : undefined}
        // placeholder={inputProps?.options[0]?.label ?? []}
        value={!inputProps?.isMulti ? { label: valueLabel, value: inputProps?.value } :
          inputProps?.value
        }
      />
      {inputProps?.error && (
        <p className='errormsg'>
          {SELECT_MESSAGE} {inputProps?.label || inputProps['aria-label']}
        </p>
      )}
    </div>
  )
})

const Option = (props: any) => {
  return (
    <div className='d-flex' >
      <components.Option {...props}>
        <input
          checked={props?.isSelected}
          onChange={() => null}
          type='checkbox'
        />{" "}
        <label>{props?.label}</label>
      </components.Option>
    </div>
  )
}

const Placeholder = (props: any) => {
  return (
        <components.Placeholder {...props}>
          All
        </components.Placeholder>
  )
}

export default CustomSelect
